#import "./peep-related-lead-card-fragment.graphql"

fragment PeepRelatedLeadCards on Peep {
    id
    type
    name
    leads(first: 100) {
        edges {
            node {
                ...PeepRelatedLeadCardFragment
            }
        }
    }
    childLeads(first: 100) {
        edges {
            node {
                ...PeepRelatedLeadCardFragment
            }
        }
    }
}
